// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Htt7","col":"styles_col__3CZcs"};